import React from 'react';
import Immutable from 'immutable';
import { createStore } from 'redux';
import { Provider } from 'react-redux';

type State = Immutable.Map<string, Immutable.Map<string, any> | undefined>;

const initialState: State = Immutable.Map({
  meta: undefined,
});

const reportReducer = (state = initialState, action) => state;

const store = createStore<State>(
  reportReducer,
  Immutable.Map({
    meta: Immutable.Map({
      publishing: window.parent.isPublishing,
      // disabling this for now as the editor forces a refresh which
      // causes the panels to be blank when shared.
      isSharedWebpage: false, // window.parent.isSharedWebpage,
    }),
  })
);

const ReportProvider = ({ children }) => {
  return <Provider store={store}>{children}</Provider>;
};

export default ReportProvider;
